import { PalletType } from 'interfaces';

export const PALLET_TYPES: Record<string, PalletType> = {
   EDHP: 'EDHP_PALLET',
   EURO: 'EURO_PALLET',
   NDHP: 'HALF_PALLET_NDHP',
   CDHP: 'QUARTER_PALLET_CDHP',
};
